import { useCallback } from "react";
import { useMutation } from "urql";

import { DEFAULT_SNACKBAR_ERROR_MESSAGE } from "../constants/strings";
import { UpdateObjects } from "../features/drive/queries.graphql";
import useShowSnackbar from "./useShowSnackbar";
import { useUrqlResponseHandler } from "./useUrqlResponseHandler";

export const useUpdateObjects = () => {
  const { showError } = useShowSnackbar();
  const { getResponseFromState } = useUrqlResponseHandler();
  const [result, executeMutation] = useMutation(UpdateObjects);

  const updateObjects = useCallback(
    async (
      objectIds: string[],
      updates: Record<string, any>,
      successMessage = "",
      errorMessage = DEFAULT_SNACKBAR_ERROR_MESSAGE,
    ) => {
      try {
        const state = await executeMutation({
          updateObjectsInput: {
            objectIds,
            ...updates,
          },
        });

        getResponseFromState({
          state,
          successMessage:
            successMessage ||
            `${objectIds.length > 1 ? "All items" : "Item"} successfully updated.`,
          errorMessage,
        });
      } catch (e) {
        console.error("Error updating items:", e);
        showError(errorMessage);
      }
    },
    [executeMutation, showError, getResponseFromState],
  );

  return { updateObjects, result };
};
